import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface ThemeRiverChartProps {
  data: Array<[string, number, string]>;
  topics: string[];
  height?: number | string;
  loading?: boolean;
}

export function ThemeRiverChart({ data, height, loading }: ThemeRiverChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'axis' },
    legend: { bottom: 0 },
    singleAxis: { top: 20, bottom: 40, type: 'time' },
    series: [{ type: 'themeRiver', data, label: { show: false } } as any],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
